export const formMixin = {
  methods: {
    isPatternDigit (value) {
      let re = /^[0-9\b]*$/
      if (re.test(value)) return true
      return false
    },
    isPatternEmail (value) {
      // eslint-disable-next-line
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (re.test(value)) return true
      return false
    },
    hasToBeAnEmail (field) {
      return this.isPatternEmail(field)
    },
    hasToBeNotEmpty (field) {
      return field.trim().length
    },
    hasToBeANumber (field) {
      return this.isPatternDigit(field)
    },
    hasToBeAValidPassword (field) {
      return field.length > 5
    },
    hasToBeAMatchPassword (oldPassword, newPassword) {
      return newPassword.length > 5 && oldPassword === newPassword
    }
  }
}
